export default __webpack_public_path__ + "static/media/up.07a217d2.svg";